import theme from "../styles/asTheme";
import {
  MdGroups2,
  MdShoppingBag,
  MdNoteAdd,
  MdStickyNote2,
} from "react-icons/md";

export const InfoCardData = [
  {
    id: "1",
    title: "Total de Usuarios Contratados",
    iconName: <MdGroups2 color={theme.palette.primary.main} />,
  },
  {
    id: "2",
    title: "Total de Usuarios Activos",
    iconName: <MdShoppingBag color={theme.palette.primary.main} />,
  },
  {
    id: "3",
    title: "Inclusiones",
    iconName: <MdNoteAdd color={theme.palette.primary.main} />,
  },
  {
    id: "4",
    title: "Otros",
    iconName: <MdStickyNote2 color={theme.palette.primary.main} />,
  },
];
